import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { additionalPageContentApi } from '@helsenorge/framework-utils/additional-page-content';
import { tjenesteTeksterApi } from '@helsenorge/framework-utils/cms-tjeneste-tekster';

import rootReducer from './reducer';
import { resourcesApi } from '../resources';
import { velgBehandlingsstedApi } from './api/velgBehandlingsstedApi';

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      // Felles
      .concat(tjenesteTeksterApi.middleware)
      .concat(resourcesApi.middleware)
      .concat(additionalPageContentApi.middleware)
      .concat(velgBehandlingsstedApi.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
